var XLSX = require("xlsx");
export const dataExporthelper = {
    exportToExcel,
    exportFromhtml
};

function exportToExcel(data,{filename = 'exported_data'}) {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
    XLSX.writeFile(wb, `${filename}.xlsx`);
}


function exportFromhtml({id,reportname = 'Rds_report',headerstart = 0}) {
    try{
        const table = document.getElementById(id);
        const rows = table.getElementsByTagName("tr");
        const rowData = [];
        
        // console.log(cells);
        // Loop through each row (skip the header row - starts from index 1)
        for (let i = 1; i < rows.length; i++) {
            const row = rows[i];
            const cells = row.getElementsByTagName("td");
            const rowDataItem = {};
            
            // Loop through each cell in the row
            for (let j = 0; j < cells.length; j++) {
            const cell = cells[j];
            const headerCell = table.rows[headerstart].cells[j]; // Get the corresponding header cell
            const columnName = headerCell.innerText.toLowerCase().replace(/\s+/g, "");
            const input = cell.querySelector("input[type='number']");
            
            const inputtext = cell.querySelector("input[type='text']");
            const inputcheckbox = cell.querySelector("input[type='checkbox']");
            
            let cellValue = ''; 
            if (input) {
                cellValue = input.value.trim();
            }
            else if(inputtext){
                cellValue = inputtext.value.trim();
               
            }else if(inputcheckbox){
                cellValue = inputcheckbox.value.trim();
            }
            else{
                if(cell != undefined){
                    cellValue = cell.innerText.trim(); 
                    cellValue = cellValue.replace("'", "");
                    let isNumber = /^\d+(\.\d+)?$/.test(cellValue);

                    // // If it's a number, convert to float; otherwise, keep it as text
                    if (isNumber) {
                        cellValue = parseFloat(cellValue);
                    }else{
                        cellValue = cellValue;
                    }
                    
                    // console.log(cellValue);    
                }
                
            }
            // if(inputtext){
            //     cellValue = inputtext.value.trim();
            // }else{
            //     if(cell != undefined){
            //     cellValue = cell.innerText.trim();
            //     }
            // }
            
            // if(inputcheckbox){
            //     cellValue = inputcheckbox.value.trim();
            // }else{
            //     if(cell != undefined){
            //     cellValue = cell.innerText.trim();
            //     }
            // }
            // const cellValue = cell.innerText.trim();
            // Add the data to the rowDataItem object using the column name as the key
            rowDataItem[columnName] = cellValue;
            }

            // Add the rowDataItem object to the rowData array
            rowData.push(rowDataItem);
        }

        const ws = XLSX.utils.json_to_sheet(rowData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
        XLSX.writeFile(wb, reportname+'.xlsx');
        // return rowData;
    }catch(error){
        console.log(error);
    }
}
